// @flow

import _ from 'lodash';
import React from 'react';
import { Icon } from '@shopify/polaris';
import {
  AppsMinor,
  ExportMinor,
  ImportMinor,
  PlayMinor,
  QuestionMarkMinor,
  ReportMinor,
  StarFilledMinor,
  CirclePlusMinor
} from '@shopify/polaris-icons';
import { ADMIN_APP_ASSET_PATHS } from 'src/constants/assets';
import { getAssetURL } from 'src/helpers';

export const TitleHelp = (props: Object) => {
  const {
    onPlay,
    hrefUserManual,
    hrefBestPractice,
    hrefFAQ,
    hrefVideoTutorial,
    i18n,
    style = {},
    openStepGuide,
    onAnalytics,
    onImport,
    onExport,
    children,
    requestNewIntegration, // <-- receive as prop
    onRequestNewIntegration // <-- optional: handler for click
  } = props;

  const handleOpenLink = link => {
    window.open(link, '_blank');
  };

  return (
    <div className="BC-Page__Title--Help" style={style}>
      {onPlay && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={onPlay}>
            <Icon source={PlayMinor} color="base" />
          </span>
          <span onClick={onPlay}>{i18n.translate('AdminHTML.Common.Action.watchTutorials')}</span>
        </div>
      )}
      {hrefUserManual && (
        <div className="BC-Page__Title--Help__Item">
          <span className="img">
            <img
              alt="learn-more"
              src={getAssetURL(ADMIN_APP_ASSET_PATHS?.common?.bookmark)}
              onClick={() => handleOpenLink(hrefUserManual)}
            />
          </span>
          <span onClick={() => handleOpenLink(hrefUserManual)}>
            {i18n.translate('AdminHTML.Common.Action.userGuide')}
          </span>
        </div>
      )}
      {/* --- Use requestNewIntegration prop here --- */}
      {requestNewIntegration && (
        <div
          className="BC-Page__Title--Help__Item"
          style={{ cursor: 'pointer', color: '#6d7175' }}
          onClick={onRequestNewIntegration}>
          <span>
            <Icon source={CirclePlusMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.requestNewIntegration')}</span>
        </div>
      )}
      {onRequestNewIntegration && (
        <div
          className="BC-Page__Title--Help__Item"
          style={{ cursor: 'pointer', color: '#6d7175' }}
          onClick={onRequestNewIntegration}>
          <span>
            <Icon source={CirclePlusMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.requestNewIntegration')}</span>
        </div>
      )}
      {/* --- End add --- */}
      {hrefFAQ && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={() => handleOpenLink(hrefFAQ)}>
            <Icon source={QuestionMarkMinor} color="base" />
          </span>
          <span onClick={() => handleOpenLink(hrefFAQ)}>
            {i18n.translate('AdminHTML.Common.Action.faqs')}
          </span>
        </div>
      )}
      {hrefBestPractice && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={() => handleOpenLink(hrefBestPractice)}>
            <Icon source={StarFilledMinor} color="base" />
          </span>
          <span onClick={() => handleOpenLink(hrefBestPractice)}>
            {i18n.translate('AdminHTML.Common.Action.bestPractices')}
          </span>
        </div>
      )}
      {hrefVideoTutorial && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={() => handleOpenLink(hrefVideoTutorial)}>
            <Icon source={PlayMinor} color="base" />
          </span>
          <span onClick={() => handleOpenLink(hrefVideoTutorial)}>
            {i18n.translate('AdminHTML.Common.Action.howToUpgradeToTurbo')}
          </span>
        </div>
      )}
      {!_.isEmpty(openStepGuide) && (
        <div className="BC-Page__Title--Help__Item">
          <span onClick={openStepGuide.onAction}>
            <Icon source={AppsMinor} color="base" />
          </span>
          <span onClick={openStepGuide.onAction}>{openStepGuide.title}</span>
        </div>
      )}
      {onAnalytics && (
        <div className="BC-Page__Title--Help__Item" onClick={() => onAnalytics()}>
          <span>
            <Icon source={ReportMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.analytics')}</span>
        </div>
      )}
      {onImport && (
        <div className="BC-Page__Title--Help__Item" onClick={() => onImport()}>
          <span>
            <Icon source={ImportMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.import')}</span>
        </div>
      )}
      {onExport && (
        <div className="BC-Page__Title--Help__Item" onClick={() => onExport()}>
          <span>
            <Icon source={ExportMinor} color="base" />
          </span>
          <span>{i18n.translate('AdminHTML.Common.Action.export')}</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default TitleHelp;
